import { inject, Injectable } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslocoService } from '@jsverse/transloco';
import { PageTitleService } from '@core/services/page-title.service';

@Injectable({ providedIn: 'root' })
export class TranslocoTitleStrategy extends TitleStrategy {
    private readonly title = inject(Title);
    private readonly transloco = inject(TranslocoService);
    private readonly pageTitle = inject(PageTitleService);

    override updateTitle(snapshot: RouterStateSnapshot): void {
        const key = this.buildTitle(snapshot);
        if (!key) {
            this.title.setTitle('ATC');
            this.pageTitle.title.set('');
            return;
        }

        // Split scope and key — "identity.login.title" → scope: "identity", key: "login.title"
        const parts = key.split('.');
        const scope = parts[0];
        const transKey = parts.slice(1).join('.');

        this.transloco.selectTranslate(transKey, {}, scope).subscribe((t) => {
            this.title.setTitle(t);
            // The topbar shows the title without the "| ATC" / "· ATC" tab suffix.
            this.pageTitle.title.set(t.replace(/\s*[|·]\s*ATC\s*$/, ''));
        });
    }
}
